import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {TasksModel} from '../../../tasks/models/tasks.model';

class CustomTextboxModel {
// tslint:disable-next-line:variable-name
    section_id: number;
    // tslint:disable-next-line:variable-name
    del_id: number;
    value: { value: string, output: string };
}

@Component({
    selector: 'app-journey-list-template-textarea',
    templateUrl: './list-template-textarea.component.html',
    styleUrls: ['./list-template-textarea.component.scss']
})
export class LearningJourneyListTemplateTextareaComponent implements OnInit {

    @Input() embedded = false;
    @Input() readonly = false;
    @Input() task: TasksModel = null;
    @Input() for_manager = false;
    @Input() for_coach = false;
    @Output() doChange: EventEmitter<CustomTextboxModel> = new EventEmitter();

    constructor() {
    }

    ngOnInit() {
    }

    onChange(event) {
        setTimeout(()=> {
            this.task.status = !!this.task.details.custom_textbox.value.value;
            this.task.click = !!this.task.details.custom_textbox.value.value;
            this.doChange.emit(this.task.details.custom_textbox);
        });
    }

}
